export default "__VITE_ASSET__BQY48CcZ__"